import React, { useEffect, useState } from "react";
import { fetchTransaction } from "../api/api";
import HeaderQC from "./HeaderQC";

const ViewTransaction = ({ transactionId, user }) => {
  const [transaction, setTransaction] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchTransaction(transactionId);
      if (data) setTransaction(data);
      else console.error("No transaction found");
      setLoading(false);
    };
    fetchData();
  }, [transactionId]);

  const handleLogout = () => {
    localStorage.removeItem("userToken");
    window.location.href = "/login";
  };

  if (loading) {
    return (
      <div className="min-h-screen d-flex align-items-center justify-content-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!transaction) {
    return (
      <div className="min-h-screen d-flex align-items-center justify-content-center">
        <div className="card border-0 shadow-sm rounded-4 text-center p-5">
          <i className="bi bi-exclamation-circle text-danger display-1 mb-3"></i>
          <h3>Transaction Not Found</h3>
          <p className="text-muted">
            The requested transaction could not be found.
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      <HeaderQC />

      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card border-0 shadow-sm rounded-4">
              <div className="card-header bg-white border-0 py-4">
                <h4 className="mb-1">Transaction Details</h4>
              </div>
              <div className="card-body p-4">
                <h6 className="text-uppercase text-muted mb-3">
                  Basic Information
                </h6>

                <p>
                  <strong>Transaction ID:</strong> {transaction.transaction_id}
                </p>
                <p>
                  <strong>Project ID:</strong> {transaction.project_id}
                </p>
                <p>
                  <strong>Actor ID:</strong> {transaction.actor_id}
                </p>
                <p>
                  <strong>Parent Node:</strong> {transaction.parent_node}
                </p>
                <p>
                  <strong>Level:</strong> {transaction.level}
                </p>
                <p>
                  <strong>Process Type:</strong> {transaction.process_type}
                </p>

                <p>
                  <strong>Entry Date:</strong> {transaction.entry_date}
                </p>
                <p>
                  <strong>Transaction:</strong> {transaction.transaction_date}
                </p>
                <p>
                  <strong>Geographical Coordinates:</strong>{" "}
                  {transaction.geographical_coordinates}
                </p>
                <p>
                  <strong>Crop:</strong> {transaction.crop}
                </p>
                <p>
                  <strong>Number of units:</strong> {transaction.no_of_units}
                </p>
                <p>
                  <strong>Quantity:</strong> {transaction.quantity}{" "}
                  {transaction.measuring_unit}
                </p>
                <p>
                  <strong>Price Per Unit:</strong> {transaction.price_per_unit}
                </p>
                <p>
                  <strong>Total Amount:</strong> {transaction.total_amount}
                </p>
                <p>
                  <strong>Status:</strong> {transaction.status}
                </p>
                <p>
                  <strong>Updated Date:</strong> {transaction.updated_date}
                </p>

                <h6 className="text-uppercase text-muted mt-4 mb-3">
                  Team Status and Remarks
                </h6>

                {["A", "B", "C"].map((team) => (
                  <div key={team} className="mb-2">
                    <strong>Team {team}:</strong>
                    <br />
                    <span>
                      Status:{" "}
                      {transaction[`team_${team.toLowerCase()}_status`] ||
                        "N/A"}
                    </span>
                    <br />
                    <span>
                      Remark:{" "}
                      {transaction[`team_${team.toLowerCase()}_remark`] ||
                        "No comment"}
                    </span>
                  </div>
                ))}

                {transaction.problem_reported === "TRUE" && (
                  <>
                    <h6 className="text-uppercase text-muted mt-4 mb-3">
                      Problem Report
                    </h6>
                    <p>
                      <strong>Problem Comment:</strong>{" "}
                      {transaction.problem_comment}
                    </p>
                  </>
                )}
                <h6 className="text-uppercase text-muted mt-4 mb-3">
                  Payment & Documents
                </h6>
                <p>
                  <strong>Payment Document:</strong>{" "}
                  <a href="/sample.png" target="_blank">
                    📄 View
                  </a>
                </p>
                <p>
                  <strong>Transaction Document:</strong>{" "}
                  <a href="/sample.png" target="_blank">
                    📄 View
                  </a>
                </p>

                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => window.history.back()}
                >
                  Go Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewTransaction;
